var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "viewRef",
    staticClass: "green_wrap"
  }, [_c('div', {
    ref: "cardGroupRef",
    staticClass: "card_group"
  }, _vm._l(_vm.greenData, function (greenItem, greenKey) {
    return _c('div', {
      key: greenKey,
      staticClass: "green_card d-flex flex-column justify-content-between"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "green_card_title"
    }, [_vm._v(_vm._s(greenKey))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: greenItem.ratio >= 1,
        expression: "greenItem.ratio >= 1"
      }],
      staticClass: "green_card_status"
    }, [_vm._v(" 已達標 ")])]), _c('div', {
      staticClass: "green_card_info d-flex"
    }, [_c('div', {
      staticClass: "green_card_percentage"
    }, [_c('div', {
      staticClass: "green_card_subtitle"
    }, [_vm._v("佔比")]), _c('div', {
      staticClass: "green_card_value"
    }, [_vm._v(" " + _vm._s(greenItem.ratio)), _c('span', {
      staticClass: "green_card_unit"
    }, [_vm._v("%")])])]), _c('div', [_c('div', {
      staticClass: "green_card_subtitle"
    }, [_vm._v("電量")]), _c('div', {
      staticClass: "green_card_value"
    }, [_vm._v(" " + _vm._s(greenItem.value)), _c('span', {
      staticClass: "green_card_unit"
    }, [_vm._v("kWh")])])])]), _c('div', {
      staticClass: "green_card_icon"
    })]);
  }), 0), _c('div', {
    staticClass: "green_chart_wrap"
  }, [_c('highcharts', {
    attrs: {
      "id": "greenChartId",
      "options": _vm.greenChartOptions
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };